import { useTranslation } from 'react-i18next';

export const Spinner = () => {
  const { t } = useTranslation();
  return (
    <div
      className="tw-inline-block tw-h-8 tw-w-8 tw-animate-spin tw-rounded-full tw-border-4 tw-border-solid tw-border-gray-400 tw-border-r-transparent tw-align-[-0.125em] tw-motion-reduce:animate-[spin_1.5s_linear_infinite]"
      role="status"
    >
      <span className="!tw-absolute !tw--m-px !tw-h-px !tw-w-px !tw-overflow-hidden !tw-whitespace-nowrap !tw-border-0 !tw-p-0 !tw-[clip:rect(0,0,0,0)]">
        {t('components.payment_loading.loading')}
      </span>
    </div>
  );
};
